// extracted by mini-css-extract-plugin
module.exports = {"appreciationTitle":"AppreciationContent-module__appreciationTitle___3TswO"};